import { render } from "./CollectionDetailedSearchOnlinePublications.vue?vue&type=template&id=ed0c78ea&scoped=true&ts=true"
import script from "./CollectionDetailedSearchOnlinePublications.vue?vue&type=script&lang=ts"
export * from "./CollectionDetailedSearchOnlinePublications.vue?vue&type=script&lang=ts"

import "./CollectionDetailedSearchOnlinePublications.vue?vue&type=style&index=0&id=ed0c78ea&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src613357358/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed0c78ea"]])

export default __exports__